<template>
  <div>
    <el-table :data="projectList" height="calc(100vh - 360px)">
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="fromUid" label="转出用户ID"></el-table-column>
      <el-table-column prop="fromBalance" label="转出后余额"></el-table-column>
      <el-table-column prop="amount" label="数量"></el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="fee" label="手续费"></el-table-column>
      <el-table-column prop="toUid" label="转入用户ID"></el-table-column>
      <el-table-column prop="toBalance" label="转入后余额"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
          <div v-if="scope.row.status === 1">{{ scope.row.notPassText }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250px">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="cancelBlack(true, scope.row.id)"
            v-if="scope.row.status === 0"
            >审核通过</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="cancelBlack(false, scope.row.id)"
            v-if="scope.row.status === 0"
            >审核不通过</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
    }
  },
  computed: {
    ...mapState('transfer', ['pagination', 'totalCount']),
    ...mapGetters('transfer', ['projectList']),
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('transfer', ['list', 'setPass']),
    ...mapMutations('transfer', ['setpage']),
    handleCurrentChange(pagination) {
      this.setpage(pagination)
      this.$emit('refresh', { pagination, type: 1 })
    },
    cancelBlack(isPass, id) {
      const action = isPass
        ? this.$confirm('确定通过审核吗？', '提示', {
            type: 'warning',
          })
        : this.$prompt('请输入审核不通过原因', '提示', {
            inputValidator: (value) => {
              return !value || !value.trim() ? '请输入不通过原因' : true
            },
          })
      action.then(({ value }) => {
        this.setPass({
          transferId: id,
          notPassText: isPass ? undefined : value,
          isOk: isPass,
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！',
            })
          })
          .finally(() => {
            this.list({ page: 1 })
          })
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
